import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return <Button icon="pi pi-arrow-up" className={`scrollTop ${isVisible ? "visible" : "hidden"}`} onClick={scrollToTop} />;
};

export default ScrollToTopButton;
